module.exports = __webpack_public_path__ + "static/slider2-min-ed319d886dc41eb3844d21e867424d92.jpg";